import { serviciosOfrecidosOptions } from "@/lib/affiliateOptions";
import { Field, SectionCard, StepShell, inputClass } from "./ui";
import type { AfiliacionForm } from "./types";

interface StepServiciosProps {
  form: AfiliacionForm;
  toggleServicio: (servicio: string) => void;
  setField: <K extends keyof AfiliacionForm>(name: K, value: AfiliacionForm[K]) => void;
  errors: Record<string, string>;
}

export default function StepServicios({
  form,
  toggleServicio,
  setField,
  errors,
}: StepServiciosProps) {
  return (
    <StepShell
      title="Servicios y disponibilidad"
      description="Indica qué tipo de servicios puedes ofrecer y tu disponibilidad general. Puedes seleccionar varios servicios."
    >
      <div className="space-y-5">
        <SectionCard title="¿Qué servicios puedes ofrecer?" icon="ri-service-line">
          <div className="flex flex-wrap gap-2.5">
            {serviciosOfrecidosOptions.map((servicio) => {
              const selected = form.servicios.includes(servicio);
              return (
                <button
                  key={servicio}
                  type="button"
                  onClick={() => toggleServicio(servicio)}
                  aria-pressed={selected}
                  className={`inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full border px-4 py-2 text-sm font-label font-medium transition-colors ${
                    selected
                      ? "border-primary-400 bg-primary-50 text-primary-800"
                      : "border-background-300 bg-background-50 text-foreground-600 hover:border-primary-300"
                  }`}
                >
                  <i
                    className={`${selected ? "ri-checkbox-circle-fill" : "ri-add-circle-line"} text-base leading-none`}
                    aria-hidden="true"
                  ></i>
                  {servicio}
                </button>
              );
            })}
          </div>
          {errors.servicios && (
            <p className="mt-3 flex items-center gap-1 text-xs text-primary-700">
              <i className="ri-error-warning-line text-sm leading-none" aria-hidden="true"></i>
              {errors.servicios}
            </p>
          )}
        </SectionCard>

        <SectionCard title="Disponibilidad general" icon="ri-time-line">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <Field label="Zona de operación" htmlFor="dispZona" optional full hint="Ej. Santo Domingo y alrededores">
              <input
                id="dispZona"
                type="text"
                value={form.dispZona}
                onChange={(event) => setField("dispZona", event.target.value)}
                placeholder="Ej. Santo Domingo, Distrito Nacional"
                className={inputClass}
              />
            </Field>
            <Field label="Días disponibles" htmlFor="dispDias" optional>
              <input
                id="dispDias"
                type="text"
                value={form.dispDias}
                onChange={(event) => setField("dispDias", event.target.value)}
                placeholder="Ej. Lunes a sábado"
                className={inputClass}
              />
            </Field>
            <Field label="Horario" htmlFor="dispHorario" optional>
              <input
                id="dispHorario"
                type="text"
                value={form.dispHorario}
                onChange={(event) => setField("dispHorario", event.target.value)}
                placeholder="Ej. 7:00 AM – 6:00 PM"
                className={inputClass}
              />
            </Field>
            <Field label="Distancia máxima" htmlFor="dispDistancia" optional>
              <input
                id="dispDistancia"
                type="text"
                value={form.dispDistancia}
                onChange={(event) => setField("dispDistancia", event.target.value)}
                placeholder="Ej. 250 km"
                className={inputClass}
              />
            </Field>
          </div>
        </SectionCard>
      </div>
    </StepShell>
  );
}